<template>
  <div class='mainContainer'>
    <div class='tabs'>
      <div @click='typeFun(0)' class='left' :class='{ active: carType === 0 }'>委托商油价费用</div>
      <div @click='typeFun(1)' class='right' :class='{ active: carType === 1 }'>供应商油价费用</div>
    </div>
    <div class='componentsContainer'>
      <!-- 委托商 -->
      <consignor v-if="carType===0" ref="consignorRef" />
      <!-- 供应商 -->
      <supplier v-else-if="carType === 1" ref="supplierRef"/>
    </div>
  </div>
</template>

<script>
import consignor from './components/consignor.vue'
import Supplier from "@/views/settle/else/components/supplier.vue";
export default {
  components: {Supplier, consignor},
  data() {
    return {
      carType: 0, // 0：委托商 1：供应商
    }
  },
  methods: {
    // 委托商/供应商 切换
    typeFun(val) {
      this.carType = val;

    },
  }
}
</script>

<style lang='scss' scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;
  background-color: #fff;


  .tabs {
    float: left;
    margin-left: 20px;
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
    width: 239px;
    margin-bottom: 20px;

    div {
      //background: #ccc;
      width: 120px;
      height: 30px;
      line-height: 30px;
      color: #48599E;
      text-align: center;
      font-size: 13px;
      cursor: pointer;
      border: 1px solid #48599E;
      font-weight: 700;
      transition: all .3s;
    }

    .left {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    .right {
      /*width: 160px;*/
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    .active {
      background: #48599E;
      color: #fff;
    }
  }
  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &Container {
      width: 200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;

      p {
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }

    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tableContainer {
      margin-top: 10px;
      margin-bottom: 25px;
      width: 100%;

      &Nav {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        span {
          color: rgba(51, 136, 255, 1);
          text-decoration: underline;
          margin-right: 10px;

          &:hover {
            cursor: pointer;
          }
        }
      }

      ::v-deep {
        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        font-size: 13px;
      }
    }
  }

  ::v-deep {
    .el-table th > .cell {
      font-weight: 700 !important;
    }
  }
}
.paginationContainer {
  margin-right: auto;
  display: flex;
  align-items: center;
  margin-bottom: 0px;

  span {
    font-size: 13px;
  }
}
.el-pagination{
  padding: 5px 3px;
}

</style>
